import type { UpdateSelectionAction } from '..';
import { UPDATE_SELECTION } from '../actionTypes';

const updateSelection = (selected: Array<string>): UpdateSelectionAction => ({
	type: UPDATE_SELECTION,
	payload: selected,
});

export default updateSelection;
